import * as React from "react";
import { Button, Modal } from "semantic-ui-react";

export const PrintDialog: React.FunctionComponent = () => {
    const [open, setModalClose] = React.useState(false);
    const onClose = () => setModalClose(false);
    const onOpen = () => setModalClose(true);
    const print = () => {
        setModalClose(false);
        setTimeout(() => { window.print(); }, 500);
    };

    return (
        <Modal
            onClose={onClose}
            onOpen={onOpen}
            open={open}
            trigger={<Button type="button" className="print-button" secondary>Print</Button>}
        >
            <Modal.Header>Print settings</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    For the best printing experience, please adjust your web browser settings
                    to make sure the Background images option is turned on. You can also adjust
                    the margin settings, to control where the page breaks. You will find these
                    settings in the Print dialogue window, which will be displayed in the next step.
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button type="button" basic onClick={onClose}>
                    Cancel
                </Button>
                <Button type="button" onClick={print}>
                    Continue
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
